import { p as palette } from '../base/color-ec580bc4.js';
import { t as typography } from '../base/typography-dd13a6be.js';

const breadcrumbs = {
  color: typography.color.secondary,
  spacer: palette.gray[300]
};
var breadcrumbs$1 = breadcrumbs;

export { breadcrumbs$1 as b };
//# sourceMappingURL=breadcrumb-fc2508bc.js.map
